import newsletter from './injectNewsletter';

export default [
  ...newsletter,
];
